// extracted by mini-css-extract-plugin
export var backgroundImage = "index-module--backgroundImage--3229c";
export var closeButton = "index-module--closeButton--7d826";
export var closeButtonContainer = "index-module--closeButtonContainer--d1b88";
export var floatingNews = "index-module--floatingNews--06e3d";
export var mobile = "index-module--mobile--a2c67";
export var pc = "index-module--pc--a80ee";
export var summary = "index-module--summary--84d9a";
export var textContent = "index-module--textContent--bf2e2";
export var title = "index-module--title--89d69";